import { FC, useContext } from 'react'
import { AppContext } from '../../AppContext'
import './HeaderButton.scss'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { HeaderButtonControl } from './HeaderButtonControl'

export const HeaderFeedbackButton: FC = () => {
  const { setFeedbackOpened, feedbackLoading, setFeedbackLoading } = useContext(AppContext)

  return (
    <HeaderButtonControl>
      <button
        className="ml-auto bg-white/10 hover:bg-white/20 active:bg-white/30 active:shadow-none"
        onClick={() => {
          logger.log(LogActionType.FeatureRequestButtonClick)

          setFeedbackOpened(true)
          setFeedbackLoading(true)
        }}
      >
        {feedbackLoading ? 'Loading...' : 'Request a feature'}
      </button>
    </HeaderButtonControl>
  )
}
